import { render, staticRenderFns } from "./BasicMsg.vue?vue&type=template&id=b8cf9802&scoped=true"
import script from "./BasicMsg.vue?vue&type=script&lang=js"
export * from "./BasicMsg.vue?vue&type=script&lang=js"
import style0 from "./BasicMsg.vue?vue&type=style&index=0&id=b8cf9802&prod&lang=scss&scoped=true"
import style1 from "./BasicMsg.vue?vue&type=style&index=1&id=b8cf9802&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cf9802",
  null
  
)

export default component.exports